module.exports = __webpack_public_path__ + "static/media/princess_mononoke.e83b83e4.jpg";